import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function Profile() {
  const { user } = useAuth();
  const [history, setHistory] = useState([]);

  useEffect(() => {
    api.get("/me/history").then((r) => setHistory(r.data));
  }, []);

  if (!user) return null;
  return (
    <div className="max-w-5xl mx-auto px-6 md:px-10 py-12" data-testid="profile-page">
      <div className="fade-up">
        <div className="label-eyebrow mb-3">Mon profil</div>
        <h1 className="font-display text-5xl mb-2">{user.firstName}</h1>
        <p className="text-[#a3a8a4]">{user.email}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[rgba(253,251,247,0.08)] border border-[rgba(253,251,247,0.08)] mt-10 fade-up-delay-1">
        <Cell label="Points" value={`${user.points}`}/>
        <Cell label="Membre depuis" value={new Date(user.created_at).toLocaleDateString("fr-FR")}/>
        <Cell label="Statut" value={user.role === "admin" ? "Administrateur" : "Client"}/>
      </div>

      <div className="mt-16 fade-up-delay-2">
        <div className="label-eyebrow mb-2">Historique complet</div>
        <h2 className="font-display text-3xl mb-6">Mouvements de points</h2>
        <div className="border border-[rgba(253,251,247,0.08)]">
          {history.length === 0 && <div className="p-8 text-[#a3a8a4]">Aucun mouvement enregistré.</div>}
          {history.map((h) => (
            <div key={h.id} className="border-b border-[rgba(253,251,247,0.05)] last:border-0 px-6 py-4 flex items-center justify-between hover:bg-[#1a241b]/40">
              <div>
                <div className="text-sm">{h.reason}</div>
                <div className="text-xs text-[#a3a8a4]">{new Date(h.created_at).toLocaleString("fr-FR")}</div>
              </div>
              <div className={h.delta >= 0 ? "gold-text" : "text-red-400"}>{h.delta >= 0 ? "+" : ""}{h.delta} pts</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function Cell({ label, value }) {
  return (
    <div className="bg-[#0a0e0b] p-8">
      <div className="label-eyebrow mb-2">{label}</div>
      <div className="font-display text-3xl">{value}</div>
    </div>
  );
}
